export default __webpack_public_path__ + "static/media/gallery-wip-pommel_03.dce897e3.jpg";